<template>
  <div>
    <section class="page__title fix text-center">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="page__title-content pt-235"></div>
          </div>
        </div>
      </div>
    </section>
    <h2 class="page_title">{{ pageTitle }}</h2>
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
.page__title {
  margin-bottom: 2rem;
  height: 25rem;
  padding: 0 !important;
  background: #000 url(~@/assets/img/1.jpg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  color: #fff;
  @include flex-center;
}
.page_title {
  text-align: center;
  margin: 48px 0;
  font-weight: 600;
}
</style>
